
import { Component, Mixins, Watch } from "vue-property-decorator";
import { Rectangle, Point } from "../../../../../../../base/domain/drawing";
import { AsyncRequestPool } from "../../../../../../../base/utilities";
import { ModelEditableMixin, MouseTrackableMixin } from "../../../../../../../base/components/system/mixins";
import { IFormatPageLocationResult } from "../IFormatPageLocatable";

@Component
export default class QuestionnaireLocatableMixin extends Mixins(ModelEditableMixin, MouseTrackableMixin) {
  data(): any {
    return {
      locatorRequestPool: new AsyncRequestPool<Rectangle, { toRectangle: () => Rectangle, result: Rectangle }>(),
    };
  }
  locatorRequestPool: AsyncRequestPool<Rectangle, { toRectangle: () => Rectangle, result: Rectangle }>;

  get isLocating(): boolean {
    return this.locatorRequestPool.isProcessing
        && !this.locatorRequestPool.processingRequest.source.result;
  }

  get locatorRectangle(): Rectangle {
    return this.isLocatorVisible
      ? this.locatorRequestPool.processingRequest.source.toRectangle()
      : new Rectangle();
  }

  get isLocatorVisible(): boolean {
    return this.isLocating
        && this.isMouseTracking;
  }

  get editingSource(): { index: number, isHit: boolean } {
    return this.value;
  }

  set editingSource(value: { index: number, isHit: boolean }) {
    this.input(value);
  }

  specifyIndexForLocator(index: number, isHit: boolean = false) {
    this.editingSource = { index, isHit };
  }

  @Watch("isMouseLeftButtonPressed")
  onMouseLeftButtonClickedForLocator(newValue: boolean) {
    if (newValue && this.isLocatorVisible && 0 <= this.editingSource.index) {
      this.locatorRequestPool.processingRequest.source.result = this.locatorRequestPool.processingRequest.source.toRectangle();
    }
  }

  async locate(rectangle: Rectangle): Promise<IFormatPageLocationResult<Rectangle>> {
    this.editingSource = { index: -1, isHit: false };
    const located = await this._locate(
      () => new Rectangle(
        new Point(rectangle.x, this.mouseLocation.y),
        rectangle.size.clone())
    );
    const result = !located
      ? null
      : {
        result: new Rectangle(new Point(0, 0), located.size),
        index: this.editingSource.index + (this.editingSource.isHit ? 1 : 0),
        isHitObject: this.editingSource.isHit,
      };
    this.editingSource = { index: -1, isHit: false };
    return result;
  }

  private async _locate(getLocatorRectangle: () => Rectangle): Promise<Rectangle> {
    if (!getLocatorRectangle) {
      throw new Error("ロケータ矩形取得ハンドラが指定されていません.実装を確認してください.");
    }
    return this.locatorRequestPool.request(
      {
        toRectangle: getLocatorRectangle,
        result: null,
      },
      this,
      async (source: { toRectangle: () => Rectangle, result: Rectangle }) => {
        await this.$wait(() => !this.isLocating);
        return source.result;
      }
    );
  }

  cancelLocating(): void {
    this.locatorRequestPool.cancel(this);
  }
}
